import { useCallback, useEffect, useState } from "react";
import * as expenseService from "../services/expenseService";

// Fired by Branch Setup after a branch is added, renamed or (de)activated so
// the per-branch menus update without a page reload.
export const EXPENSE_BRANCHES_CHANGED = "expense-branches-changed";
export const notifyExpenseBranchesChanged = () => window.dispatchEvent(new Event(EXPENSE_BRANCHES_CHANGED));

// Active branches ([{ id, name }], name-ordered by the API) that drive the
// Branch Jobs menus. `enabled` should be true only for car-service vendors, so
// other industries never call the endpoint. `loaded` flips once the first
// request settles, so callers can tell "no branches" from "not fetched yet".
export default function useExpenseBranches(enabled) {
  const [branches, setBranches] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await expenseService.getCenters({ status: "ACTIVE" });
      setBranches(res?.success && Array.isArray(res.data) ? res.data.map(({ id, name }) => ({ id, name })) : []);
    } catch {
      setBranches([]);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    load();
    window.addEventListener(EXPENSE_BRANCHES_CHANGED, load);
    return () => window.removeEventListener(EXPENSE_BRANCHES_CHANGED, load);
  }, [enabled, load]);

  return { branches, loaded };
}
